import { getFaqsList } from "../../../app/api/getFaqsList";
import { BaseAction } from "../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { IApiResponse } from "../../../Orchestrator/Types/Index";
import {
  IFaqResponse,
  IGetFaqListActionParams,
} from "../../../Orchestrator/Types/Interface/INeedHelp";

class GetFaqListAction extends BaseAction<
  IFaqResponse,
  IGetFaqListActionParams
> {
  override async run(): Promise<IFaqResponse | null> {
    let faqResponse: IFaqResponse | null = null;
    let { intl } = this.params!;

    try {
      updateRecoilState("selectFaqLoading", true);
      const response: IApiResponse<IFaqResponse> = await getFaqsList(intl);
      if (response.status === "ok" && response.answer) {
        const data = response.answer;
        if (data) {
          faqResponse = data;
          updateRecoilState("selectFaqAtom", faqResponse.data); // Make sure this atom is defined
        } else {
          console.error("No FAQ data available.");
        }
      } else {
        console.error("Failed to fetch FAQ data.");
      }
    } catch (error: any) {
      console.error("Error fetching FAQ data:", error);
    } finally {
      updateRecoilState("selectFaqLoading", false);
      return faqResponse;
    }
  }
}

export const getFaqListAction = new GetFaqListAction();
